import React from 'react';

export default function KeyAnalytics() {
  return <div>KeyAnalytics</div>;
}
